import React from 'react';
import { ThemeProvider } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import './App.css';
import UploadPage from './upload/UploadPage';
import { CustomAuthenticator } from './auth/CustomAuthenticator';
import Header from './commons/Header';
import { Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import AdminPanel from './admin/adminPanel';
import CreateProjectForm from './project/CreateProjectForm';
import CreateUsertForm from './user/CreateUserForm';
import { useEffect, useState } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';
import {  getUserByUsername } from './graphql/queries';
import { generateClient } from 'aws-amplify/api';
import AssignUserProjectForm from './assing/AssingUserProjectForm';

const client = generateClient();

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [userName, setUserName] = useState('');
  const [role, setRole] = useState('Cliente');

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const currentUser = await getCurrentUser();
      const username = currentUser.username;

      setUserName(username);
      const User = await client.graphql({
        query: getUserByUsername,
        variables: { username }
      });
      const isAdminData = User.data.getUserByUsername.items[0].isAdmin;
      const roleUser = User.data.getUserByUsername.items[0].role;
      setIsAdmin(isAdminData);
      setRole(roleUser);
    } catch (error) {
      console.log('Error fetching user:', error);
    }
  };

  return (
    <ThemeProvider>
      <CustomAuthenticator>
        <div className="App">
          <Header isAdmin={isAdmin} role={role} />
          <Routes>
            <Route path='/' element={<HomePage userName={userName} role={role} isAdmin={isAdmin} />} />
            <Route path='/admin' element={<AdminPanel isAdmin={isAdmin} role={role} />} />
            <Route path='/admin/project/form' element={<CreateProjectForm isAdmin={isAdmin} role={role} />} />
            <Route path='/admin/user/form' element={<CreateUsertForm isAdmin={isAdmin} role={role} />} />
            <Route path='/admin/assing/form' element={<AssignUserProjectForm isAdmin={isAdmin} role={role} />} />
            <Route path='/load-files' element={<UploadPage isAdmin={isAdmin} role={role} />} />
          </Routes>
        </div>
      </CustomAuthenticator>
    </ThemeProvider>
  );
}

export default App;
